import Plugin from '../core/Plugin';
import { PlayerEvent } from './../PlayerEvents';
import { KV } from '../core/Constant';
import log from 'loglevel';

const TENCENT_DELAY = 90;

/**
 * 直播时移插件
 *
 * @export
 * @class LiveTimeshift
 * @extends {Plugin}
 */
export default class LiveTimeshift extends Plugin {
  constructor() {
    super();
    this._allConfig = null;
  }

  init(opts = {}) {
    // 调度完成后才知道是什么cdn，此时还不知道
    if (!opts.isLive || !opts.isOpenTimeshift || opts.type !== 'hls' || this.player.player._type === 'FlashPlayer') {
      return;
    }
    super.init(opts);
    this._allConfig = opts;
    this.isLive = opts.isLive;
    this.isOpenTimeshift = opts.isOpenTimeshift;
    this.type = opts.type;
    this._handleCareEvent();
  }

  _handleCareEvent() {
    this.player.on(PlayerEvent.LIVE_TIMESHIFT, this._buildURL.bind(this));
    this.player.on(PlayerEvent.LOADEDMETADATA, this._handleTime.bind(this));
  }

  _buildURL(e) {
    if (this.type !== 'hls') {
      log.warn(`${this.type}格式不支持直播时移`);
      return;
    }

    if (this.player.getCdnName() !== 'tx') {
      log.warn('当前只支持txcdn时移');
      return;
    }

    const player = this.player.player;
    const oldUrl = this.player.getStore().getKV(KV.URL);
    log.info(`oldUrl = ${oldUrl}`);
    // 进度条计算的delay
    let delay = e.delay;
    // 相对时移时间
    if (delay < TENCENT_DELAY) {
      delay = TENCENT_DELAY;
    } else {
      delay = Math.round(delay);
    }

    const oldBaseUrl = oldUrl.split('?')[0];
    // 获取token
    let token = this.player.newToken;
    const param = {
      oldBaseUrl: oldBaseUrl,
      // shiftStartTime: shiftStartTime,
      delay: delay,
      token: token
    };

    let url = '';
    switch (player.cdnName) {
      case 'ali':
        url = this.creatAliyunTimeShiftUrl(param);
        break;
      case 'tx':
        url = this.creatTencentTimeShiftUrl(param);
        break;
      default:
        break;
    }

    // log.info( `currentTime = ${this.player.getCurrentTime()}`);
    player.setSrc(url);
    this.player.player.delay = delay;
    // 兼容ios 手动调用播放
    if (!player.getIsPaused()) {
      player.play();
    }
  }

  creatAliyunTimeShiftUrl(param) {
    return `${param.oldBaseUrl}?aliyunols=on&lhs_start_human_s_8=${param.shiftStartTime}`;
  }

  creatTencentTimeShiftUrl(param) {
    return `${param.oldBaseUrl}?delay=${param.delay}&token=${param.token}`;
  }

  _handleTime() {
    if (this.player.getCdnName() !== 'tx') {
      return;
    }

    if (this._allConfig.live_duration < TENCENT_DELAY) {
      if (!this.player.player.progressStartTime) {
        // 记录进度条最左侧的时间
        this.player.player.progressStartTime = Date.now() / 1000 - this.player.player.delay;
      }
    } else {
      if (!this.player.player.progressStartTime) {
        this.player.player.progressStartTime = Date.now() / 1000 - this._allConfig.live_duration;
      }
    }
  }

  destroy() {
    super.destroy();
    // 清理事件监听
    this.player.off(PlayerEvent.LIVE_TIMESHIFT, this._buildURL);
    this.player.off(PlayerEvent.LOADEDMETADATA, this._handleTime);
  }

  static get type() {
    return 'plugin_timeshift';
  }
}
